import html2canvas from "html2canvas";
// import { Store, set, get, clear } from "idb-keyval";

const JSON = require("circular-json");

var fs = require("fs");
var localforage = require("localforage");
const proxy = "https://crossorigin.me";

localforage.config({
  driver: [localforage.INDEXEDDB, localforage.WEBSQL, localforage.LOCALSTORAGE],
  name: "Rocktion"
});
// localforage.clear();
export const readSVG = path => {
  var data = "";

  var readStream = fs.createReadStream(path, "utf8");

  readStream
    .on("data", function(chunk) {
      data += chunk;
    })
    .on("end", function() {
      return data;
    });
};

export const saveImage = ({ format, scene, backgroundColor }) => {
  if (format === "png" && !backgroundColor) {
    backgroundColor = null;
  } else {
    backgroundColor = "#fff";
  }

  html2canvas(document.getElementById(`scene-${scene}`), {
    backgroundColor
  }).then(function(canvas) {
    const a = document.createElement("a");
    a.href = canvas
      .toDataURL(`image/${format}`)
      .replace(`image/${format}`, "image/octet-stream");
    a.download = `humaaans.${format}`;
    a.click();
  });
};

export const saveScenesToLocalStorage = scenes => {
  console.log(scenes);
  localStorage.setItem("scenes", JSON.stringify(scenes));
};

export const loadScenesFromLocalStorage = () => {
  var scenes = localStorage.getItem("scenes");
  console.log(scenes);

  try {
    var jsonData = JSON.parse(scenes);
  } catch {
    var jsonData = null;
  }
  return jsonData;
};

export const createStorage = () => {};

export const saveScenesToStorage = scenes => {
  console.log(scenes);
  localforage
    .setItem("scenes", JSON.stringify(scenes))
    .then(function(value) {
      console.log("Saved");
      return { success: true };
    })
    .catch(function(err) {
      console.log(err);
      return { success: false, error: err };
    });
};

export const loadScenesFromStorage = callback => {
  localforage
    .getItem("scenes")
    .then(function(value) {
      console.log(value);
      callback({ success: true, data: JSON.parse(value) });
    })
    .catch(function(err) {
      console.log(err);
      return { success: false, error: err };
    });
};
